import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  Renderer2,
  OnDestroy
} from '@angular/core';

import {
  EventInput,
  Calendar,
  EventApi,
  EventClickArg,
  EventDropArg,
  DatesSetArg,
  EventContentArg,
  CalendarOptions
} from '@fullcalendar/core';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';

import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ProjectActivity} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import * as _ from 'underscore';

import {OverlayPanel} from 'primeng/overlaypanel';
import {timer, Subject, Subscription} from 'rxjs';
import {CalendarEventsService} from '../data/calendar-events.service';
import {FcRenderEvent} from '../data/fc-render-event';
import * as moment from 'moment';
import * as jq from 'jquery';
import {CalendarEventTipService} from '../data/calendar-event-tip.service';
import {FcJsEvent} from '../data/fc-js-event';
import {MatDialog} from '@angular/material/dialog';
import {ProjectWindowComponent} from '../../project/view/project-window/project-window.component';
import {CalendarEventsStore} from '../data/calendar-events.store';
import {CalendarEventsQuery} from '../data/calendar-events.query';
import {transaction} from '@datorama/akita/';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {filter, debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {DeviceDetectorService} from 'ngx-device-detector';
import {LocalStorage} from 'ngx-webstorage';

import {ProjectInfoComponent} from 'projects/mobile/src/app/modules/project/view/project-info/project-info.component';
import {User} from 'projects/core/src/lib/login/data/user';
import {AppStateQuery} from '../../../data/app-state.query';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {QBService} from 'projects/app-misc/src/app/modules/qb/data/qb.service';
import {CalendarEstimateSale} from 'projects/app-misc/src/app/modules/qb/data/calendar-estimate-sale';
import {
  ScheduleEstimatesDialogComponent
} from 'projects/app-misc/src/app/modules/reports/view/schedule-estimates-dialog/schedule-estimates-dialog.component';
import {WsService} from '../../../../../../app-misc/src/app/modules/data/ws.service';
import {WsUpdateResponce} from '../../../../../../app-misc/src/app/modules/data/ws-update-responce';
import {ShortProject} from '../../../../../../app-misc/src/app/modules/project-misc/data/project/short-project';
import {RouterService} from '../../../../../../core/src/lib/misc/router/router.service';
import {MvcExceptionResponse} from '../../../../../../core/src/lib/core/data/mvc-exception-response';
import {ConfirmationService} from 'primeng/api';
import {MiscSnackBarService} from '../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';


interface EventsFilterInputHolder {
  eventApi: EventApi,
  eventInput: EventInput,
  activity: ProjectActivity,
  eventEls: HTMLElement[]
} // Interface for filter result holder
type EventsFilterComparatorFunction = (inputHolder: EventsFilterInputHolder) => boolean; // Type for filter function

@Component({
  selector: 'app-full-calendar',
  templateUrl: './full-calendar.component.html',
  styleUrls: ['./full-calendar.component.scss'],
  providers: [
    CalendarEventsStore,
    CalendarEventsService,
    CalendarEventsQuery,
    DeviceDetectorService,
    ConfirmationService
  ]
})
@RxJSUnsubscribe
export class FullCalendarComponent implements OnInit, AfterViewInit, OnDestroy, RxJSUnsubscribable {

  @ViewChild('fc', {static: true})
  fc: any;

  @ViewChild('eventHintOP', {static: true})
  eventHintOP: OverlayPanel

  @ViewChild('holidayOp', {static: true})
  holidayOp: OverlayPanel

  loadingEvents = true;

  options: CalendarOptions;

  monthToShow = new Date();

  activityInHint: ProjectActivity;
  holidayStr: string;

  filtered$ = this.calendarEventsQuery.filtered$

  late = false;

  isTablet = false;
  isMobile = false;

  startDate: Date;
  endDate: Date;

  cleanStartDate: Date;
  cleanEndDate: Date;

  @LocalStorage()
  scheduleScroll: number;

  scrollDocListener = null;

  lastScrollPx: number;

  currentUser: User;

  deliveredNSold: CalendarEstimateSale

  protected scrollSubj = new Subject<number>();

  subToDateChangesSubj = new Subject<DatesSetArg>();

  wsSocketSub: Subscription;

  tempActivities: ProjectActivity[]
  deliveryLoading = false;

  private lastClickTime = 0;
  private lastClickedEventId: string = null;
  private doubleClickDelay = 300;
  private singleClickTimeout: any = null;

  constructor(
    protected wsService: WsService,
    protected appStateQuery: AppStateQuery,
    protected dialog: MatDialog,
    protected projectService: ProjectService,
    protected qbService: QBService,
    protected confirmationService: ConfirmationService,
    protected projectActivityService: ProjectActivityService,
    protected calendarEventsService: CalendarEventsService,
    protected calendarEventTipService: CalendarEventTipService,
    protected calendarEventsStore: CalendarEventsStore,
    protected calendarEventsQuery: CalendarEventsQuery,
    protected deviceDetectorService: DeviceDetectorService,
    protected miscSnackBarService: MiscSnackBarService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2,
    protected routerService: RouterService
  ) {
    this.isTablet = this.deviceDetectorService.isTablet();
    this.isMobile = this.deviceDetectorService.isMobile();
  }


  get calendar(): Calendar {
    return this.fc.calendar as Calendar
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(currentUser => this.currentUser = currentUser);

    this.calendarEventTipService.eventHintOP = this.eventHintOP;

    this.calendarEventsQuery
      .dateRange$
      .pipe(
        filter(dateRange => !!(dateRange && dateRange.start && dateRange.end)),
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(dateRange => {
        this.calendarEventsService.loadEventsForCalendar(dateRange)
      })

    this.calendarEventsQuery.selectSet$
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(events => {
        if (this.calendar && events.length >= 0) {
          this.calendar.removeAllEvents();
          this.calendar.addEventSource(events);
          this.loadingEvents = false;
        }
      })

    this.calendarEventsService.loadingEvents$
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(status => {

        if (!status) {
          this.loadingEvents = false

          this.initScrollListening();

          if (this.lastScrollPx >= 0) {
            timer(1).subscribe(() => {
              const scrollElems: HTMLElement[] = this.fc.element.nativeElement.getElementsByClassName('fc-scroller');
              if (scrollElems[1]) {
                const scrollEl = scrollElems[1];
                scrollEl.removeEventListener('scroll', this.scrollDocListener);
                scrollEl.scrollTop = this.lastScrollPx;
                setTimeout(() => {
                  scrollEl.addEventListener('scroll', this.scrollDocListener);
                }, 1);
              }
            })

          } else {
            this.scrollToToday()
          }
        }
      })

    this.subToDateChanges();

    this.options = {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      // initialView: 'dayGridMonth',
      initialDate: this.monthToShow,
      // timeZone: 'America/Vancouver',
      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday

        startTime: '10:00', // a start time (10am in this example)
        endTime: '18:00', // an end time (6pm in this example)
      },
      buttonText: {
        today: 'This Month',
      },
      headerToolbar: {
        left: '',
        center: 'prev,title,next today',
        right: ''
      },
      height: 840,
      editable: true,
      displayEventTime: false,
      weekends: false,
      eventClick: (info: EventClickArg) => {
        this.onEventClick(info)
      },
      eventDrop: (info: EventDropArg) => {
        this.onEventDrop(info)
      },
      datesSet: (info: DatesSetArg) => {
        this.loadingEvents = true
        this.subToDateChangesSubj.next(info)
      },
      eventContent: (info: EventContentArg) => {
        const result = this.eventRenderTemplate(info);
        return { domNodes: [this.createElementFromHTML(result.html)] };
      },
      eventDidMount: (info: EventContentArg) => {
        this.eventDidMount(info)
      },
      eventMouseEnter: (info: EventClickArg) => {
        info.el.classList.add('event-on-hover');
      },
      eventMouseLeave: (info: EventClickArg) => {
        info.el.classList.remove('event-on-hover');
      },
    }

    this.wsSub()
  }

  eventDidMount(eventInfo) {
    const projectActivity = this.calendarEventsService.eventsMap.get(eventInfo.event.id)

    eventInfo.el.style.setProperty('--activity-type-color', '#' + projectActivity.type.color)

    if (projectActivity.type.name === 'Installation' && projectActivity.user) {
      eventInfo.el.style.setProperty('--activity-install-color', '#' + projectActivity.user.bgColor)
    }

    if (projectActivity.isSample) {
      eventInfo.el.style.setProperty('--activity-type-color', '#f8ae29')
    }

    const shtEl = jq(eventInfo.el.getElementsByClassName('event-shortcode'))

    // tslint:disable-next-line: deprecation
    shtEl.hover(() => {
      this.showHint(eventInfo)
    }, () => {
      this.hideHint()
    })

    const deliveryMarkEl = jq(eventInfo.el.getElementsByClassName('delivery-instruction-mark'))

    // tslint:disable-next-line: deprecation
    deliveryMarkEl.hover(() => {
      this.showHint(eventInfo)
    }, () => {
      this.hideHint()
    })

    if (!this.calendarEventsService.eventsElsMap.has(eventInfo.event.id)) {
      this.calendarEventsService.eventsElsMap.set(eventInfo.event.id, [])
    }

    this.calendarEventsService.eventsElsMap.get(eventInfo.event.id).push(eventInfo.el)
  }

  eventRenderTemplate(eventInfo: EventContentArg) {
    const projectActivity = this.calendarEventsService.eventsMap.get(eventInfo.event.id)

    let shortCode = projectActivity.type.shortCode

    const userCode = projectActivity.user?.shortCode ? '(' + projectActivity.user?.shortCode + ')' : ''

    if (!shortCode) {
      shortCode = '-'
    }

    let htmlSpanToShow = shortCode;
    let htmlIconToShow = '';

    if (projectActivity.type.name === 'PunchListDue' && projectActivity.isSample) {
      htmlSpanToShow = 'S' + htmlSpanToShow
    }

    if (projectActivity.type.name === 'Installation') {
      htmlSpanToShow += userCode
    }

    if (projectActivity.type.name === 'FinishingSubmit' || projectActivity.type.name === 'FinishingPickup') {
      if (projectActivity.project.finishingVendor && projectActivity.project.finishingVendor.name === 'Acadia Craft') {
        htmlSpanToShow += ('(AC)')
      }
      if (projectActivity.project.finishingVendor && projectActivity.project.finishingVendor.name === 'PCFI FINISHING') {
        htmlSpanToShow += ('(PCFI)')
      }
    }
    if (projectActivity.workloadAware) {
      htmlIconToShow = `<div class="workload-aware-icon" pTooltip="Workload calculations (BETA) were applied" tooltipPosition="bottom">
                  <mat-icon class="mat-icon notranslate status-icn material-icons mat-icon-no-color">error</mat-icon>
              </div>`;
    }

    return {
      html: `
  		<div class="fc-content">
  			<div class="event-box">
  				<div class="event-title">
  					<span class="event-title-span">${eventInfo.event.title}<span>
  				</div>
          ${htmlIconToShow}
  				<div class="delivery-instruction-mark">
            <i class="pi pi-exclamation-triangle" style="font-size: 100%"></i>
  				</div>
  				<div class="event-dot-container">
  					<div class="event-dot"></div>
  				</div>
  				<div class="event-shortcode">
  					<span class="activity-short-code">${htmlSpanToShow}</span>
  				</div>
  			</div>
  		</div>
  	`
    }

  }

  showHint(info: FcJsEvent) {
    this.activityInHint = this.calendarEventsService.eventsMap.get(info.event.id)

    this.calendarEventTipService.showHint(info);
  }

  hideHint() {
    this.calendarEventTipService.hideHint();
  }

  openProjectInTablet(eventInfo: FcRenderEvent) {
    const eventInput = this.calendarEventsQuery.getEntity(eventInfo.event.id as string)
    if (eventInput.classNames.includes('clicked-event')) {

      this.openProjectWindow(eventInfo)
    }

  }

  openProjectWindow(eventInfo: FcRenderEvent): void {
    const clickedProjectActivity = this.calendarEventsService.eventsMap.get(eventInfo.event.id)

    let projectWindow = ProjectWindowComponent as any;

    let panelClass = 'project-window-dialog'

    if (this.isMobile || this.isTablet) {
      projectWindow = ProjectInfoComponent
      panelClass = 'project-info-dialog'
    }

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: clickedProjectActivity.project.id,
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(() => {
      this.calendarEventsStore.updateDateRange(this.startDate, this.endDate);
    });
  }

  openLastDrawing(eventInfo: FcRenderEvent): void {
    const clickedProjectActivity = this.calendarEventsService.eventsMap.get(eventInfo.event.id)
    const projectId = clickedProjectActivity.project.id

    this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: clickedProjectActivity.project.name,
        link: '/project/' + projectId + '/files/last-drawing',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  @transaction()
  onEventClick(info: EventClickArg) {
    if (this.isMobile || this.isTablet) {
      info.jsEvent.preventDefault();
      info.jsEvent.stopPropagation();
    }

    const currentTime = Date.now();
    const eventId = info.event.id;

    if (this.lastClickedEventId === eventId &&
        (currentTime - this.lastClickTime) < this.doubleClickDelay) {

      if (this.singleClickTimeout) {
        clearTimeout(this.singleClickTimeout);
        this.singleClickTimeout = null;
      }

      if (this.isTablet || this.isMobile) {
        if (this.currentUser.installationUser) {
          this.openLastDrawing(info as any);
        } else {
          this.openProjectWindow(info as any);
        }
      } else {
        if (this.currentUser.installationUser) {
          this.openLastDrawing(info as any);
        } else {
          this.openProjectWindow(info as any);
        }
      }

      this.lastClickTime = 0;
      this.lastClickedEventId = null;

      return;
    }

    if (this.singleClickTimeout) {
      clearTimeout(this.singleClickTimeout);
    }

    this.lastClickTime = currentTime;
    this.lastClickedEventId = eventId;

    this.handleSingleClick(info);

    this.singleClickTimeout = setTimeout(() => {
      this.singleClickTimeout = null;
    }, this.doubleClickDelay);
  }

  private handleSingleClick(info: EventClickArg) {
    const target = info.jsEvent.target as HTMLElement
    const clickedProjectActivity = this.calendarEventsService.eventsMap.get(info.event.id)

    let eventsFilter: EventsFilterComparatorFunction;

    if (target.matches('.event-shortcode') || target.matches('.activity-short-code')) {
      eventsFilter = inputHolder => {
        return clickedProjectActivity.type.id === inputHolder.activity.type.id
      }
    } else if (target.matches('.event-title-span')) {
      eventsFilter = inputHolder => {
        return clickedProjectActivity.project.id === inputHolder.activity.project.id
      }
    } else {
      eventsFilter = inputHolder => {
        return clickedProjectActivity.id === inputHolder.activity.id
      }
    }

    const clickedCssClass = 'clicked-event'

    const allEvents = this.calendarEventsQuery.getAll()
    allEvents.map(eventInput => {
      const eventId = eventInput.id as string
      const eventApi = this.calendar.getEventById(eventId)
      const eventEls = this.calendarEventsService.eventsElsMap.get(eventId)

      if (eventInput.classNames.includes(clickedCssClass)) {

        this.calendarEventsStore.update(eventId as any, {
          classNames: _.without(eventInput.classNames, clickedCssClass)
        })

        if (eventEls) {
          eventEls.forEach(eventEl => {
            this.renderer.removeClass(eventEl, clickedCssClass)
          })
        }
      }

      return {
        eventApi,
        eventInput,
        activity: this.calendarEventsService.eventsMap.get(eventId),
        eventEls
      } as EventsFilterInputHolder
    })
      .filter(eventsFilter)
      .map(inputHolder => {
        const classNames = [...inputHolder.eventInput.classNames as string[]]
        classNames.push(clickedCssClass)
        this.calendarEventsStore.update(inputHolder.eventInput.id as any, {
          classNames
        })

        if (inputHolder.eventEls) {
          inputHolder.eventEls.forEach(eventEl => {
            this.renderer.addClass(eventEl, clickedCssClass)
          })
        }
      })

  }

  onEventDrop(info: EventDropArg) {
    const draggedActivity = this.calendarEventsService.eventsMap.get(info.event.id);
    const activityId = draggedActivity.id;

    this.projectActivityService.saveProjectActivity({
      id: activityId,
      startDate: new Date(info.event.start.getTime()),
      endDate: new Date(info.event.end.getTime()),
    }, true)
      .subscribe((updatedActivity) => {
        const relatedActivities = this.calendarEventsService.activityUserMap.get(activityId);
        if (relatedActivities) {
          relatedActivities.forEach((activity, userId) => {
            const eventId = `${activityId}-${userId}`;
            const projectActivity = this.calendarEventsService.eventsMap.get(eventId);
            if (projectActivity) {
              projectActivity.startDate = updatedActivity.startDate;
              projectActivity.endDate = updatedActivity.endDate;
            }

            const eventApi = this.calendar.getEventById(eventId);
            if (eventApi && eventId !== info.event.id) {
              eventApi.setStart(info.event.start);
              eventApi.setEnd(info.event.end);
            }
          });
        }
      }, error => {
        if (error instanceof MvcExceptionResponse && error.type === 'SupressableException') {
          this.openConfirmationDialog(info, error.message)
        } else {
          this.miscSnackBarService.openErrorSnackBar(error.message)
          info.event.setStart(info.oldEvent.start)
          info.event.setEnd(info.oldEvent.end)
        }
      })
  }

  openConfirmationDialog(info: EventDropArg, message: string) {
    this.confirmationService.confirm({
      header: 'Confirm Move',
      message: `${message}. Would you still like to proceed?`,
      accept: () => {
        const draggedActivity = this.calendarEventsService.eventsMap.get(info.event.id);
        const activityId = draggedActivity.id;

        this.projectActivityService.saveProjectActivity({
          id: activityId,
          startDate: new Date(info.event.start.getTime()),
          endDate: new Date(info.event.end.getTime()),
        }, false)
          .subscribe((updatedActivity) => {
            const relatedActivities = this.calendarEventsService.activityUserMap.get(activityId);
            if (relatedActivities) {
              relatedActivities.forEach((activity, userId) => {
                const eventId = `${activityId}-${userId}`;
                const projectActivity = this.calendarEventsService.eventsMap.get(eventId);
                if (projectActivity) {
                  projectActivity.startDate = updatedActivity.startDate;
                  projectActivity.endDate = updatedActivity.endDate;
                }

                const eventApi = this.calendar.getEventById(eventId);
                if (eventApi && eventId !== info.event.id) {
                  eventApi.setStart(info.event.start);
                  eventApi.setEnd(info.event.end);
                }
              });
            }
          }, error => {
            info.event.setStart(info.oldEvent.start)
            info.event.setEnd(info.oldEvent.end);

            this.miscSnackBarService.openErrorSnackBar(error.message)
          })
      }, reject: () => {
        info.event.setStart(info.oldEvent.start)
        info.event.setEnd(info.oldEvent.end)
      }
    });
  }


  ngAfterViewInit() {
  }

  scrollToToday() {
    const scrollElems: HTMLElement[] = this.fc.element.nativeElement.getElementsByClassName('fc-scroller');
    if (scrollElems[1]) {

      const scrollEl: HTMLElement = scrollElems[1]
      const todayElems = scrollEl.getElementsByClassName('fc-day-today')

      if (todayElems[0]) {

        setTimeout(() => {
          const todayElement = todayElems[0] as HTMLElement;
          const scrollContainer = scrollEl;
          const containerRect = scrollContainer.getBoundingClientRect();
          const elementRect = todayElement.getBoundingClientRect();
          const scrollOffset = elementRect.top - containerRect.top + scrollContainer.scrollTop;
          scrollContainer.scrollTop = scrollOffset;
        }, 1)

      }
    }

  }

  updateCalendarHeight() {

    if (this.calendar) {
      this.calendar.setOption('height', this.fc.element.nativeElement.clientHeight - 2)
    } else {
      let retries = 0;

      timer(250).subscribe(() => {
        if (++retries <= 3) {
          this.updateCalendarHeight();
        }
      })
    }
  }

  onDateChange(info: DatesSetArg) {
    this.startDate = info.view.activeStart;
    this.endDate = info.view.activeEnd;

    this.cleanStartDate = info.view.currentStart;
    this.cleanEndDate = info.view.currentEnd;

    this.updateEstimates()

    this.calendarEventsStore.updateDateRange(this.startDate, this.endDate);

    // this.scrollToToday();

    this.fillHolidays();

    this.scrollSubj.observers = [];

    this.lastScrollPx = undefined;


    const contentToShow = jq(this.elementRef.nativeElement.getElementsByClassName('fc-media-screen'))

    const clickedCssClass = 'clicked-event'

    const notPermittedArray = [
      'event-box',
      'event-title',
      'event-title-span',
      'event-shortcode',
      'event-dot',
      'activity-short-code',
      'fc-scrollgrid-sync-inner'
    ];

    // tslint:disable-next-line: deprecation
    contentToShow.unbind();

    // tslint:disable-next-line: deprecation
    contentToShow.click(jQEvent => {
      if (!notPermittedArray.includes((jQEvent.target as HTMLElement).className)) {
        if (this.calendarEventsService.eventsElsMap.size > 0) {
          this.calendarEventsService.eventsElsMap.forEach((values) => {

            values.forEach(val => {
              this.renderer.removeClass(val, clickedCssClass)
            })
          })
        }

      }
    })
  }

  updateEstimates() {
    if (this.currentUser.installationUser || !this.currentUser.adminNSuperNSales) return;

    const startDate = moment(this.cleanStartDate).startOf('month').format('YYYY-MM-DD');
    const endDate = moment(this.cleanStartDate).endOf('month').format('YYYY-MM-DD');

    this.qbService.getDeliveredProjectEstimatesTotal(startDate, endDate).subscribe(res => {
      this.deliveredNSold = res;
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  fillHolidays() {
    const startDate = moment(this.startDate).format('YYYY-MM-DD');
    const endDate = moment(this.endDate).format('YYYY-MM-DD');
    const map = new Map();

    this.projectActivityService.getHolidays(startDate, endDate).subscribe(days => {
      days.forEach(day => {
        const date = moment(day.date).format('LL')
        map.set(date + '', day.name)
      })


      const headDays = (this.fc.element.nativeElement as HTMLElement).getElementsByClassName('fc-daygrid-day-top');

      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < headDays.length; i++) {
        const aBlock = headDays[i].children[0]

        if (aBlock.attributes[2].name === 'aria-label') {
          if (aBlock.attributes[2].value && map.has(aBlock.attributes[2].value)) {
            const holiday = map.get(aBlock.attributes[2].value);

            const holidaySpan = document.createElement('a')
            holidaySpan.innerHTML = 'H';

            holidaySpan.classList.add('holiday-mark')

            const holidayEl = jq(holidaySpan)

            // tslint:disable-next-line: deprecation
            holidayEl.hover(jQEvent => {
              this.holidayStr = holiday
              this.holidayOp.show(null, jQEvent.target)

            }, () => {
              this.holidayOp.hide()
            })

            if (headDays[i].children.length === 1) {
              headDays[i].appendChild(holidaySpan)
            }
          }
        }
      }

    })

  }

  initScrollListening() {
    this.scrollDocListener = (event) => {
      const target = event.target as HTMLElement;
      if (target && target.classList.contains('fc-scroller')) {
        this.scrollSubj.next(target.scrollTop)
      }
    }


    const scrollElems: HTMLElement[] = this.fc.element.nativeElement.getElementsByClassName('fc-scroller');

    if (scrollElems[1]) {
      scrollElems[1].addEventListener('scroll', this.scrollDocListener);
    }


    this.scrollSubj
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        debounceTime(250),
        distinctUntilChanged()
      )
      .subscribe(yScroll => {
        this.lastScrollPx = yScroll;
        // this.changeDetectorRef.detectChanges();
      })

  }

  ngOnDestroy() {
    this.subToDateChangesSubj.unsubscribe()
    this.subToDateChangesSubj = null


    if (this.wsSocketSub) {
      this.wsSocketSub.unsubscribe()
      this.wsSocketSub = null;
    }
  }

  createElementFromHTML(htmlString: string): HTMLElement {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild as HTMLElement;
  }
  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  openTransactionsWindow() {
    const startDate = moment(this.cleanStartDate).startOf('month').format('YYYY-MM-DD');
    const endDate = moment(this.cleanStartDate).endOf('month').format('YYYY-MM-DD');

    if (!this.isMobile) {
      this.dialog.open(ScheduleEstimatesDialogComponent, {
        data: {
          userId: -1,
          userName: '',
          startDate,
          finishDate: endDate,
          info: null,
          fromSchedule: true
        },
        panelClass: 'schedule-estimates-dialog',
        disableClose: false
      }).afterClosed().subscribe(result => {
          this.updateEstimates();
      });
    }
  }

  private subToDateChanges() {
    this.subToDateChangesSubj.pipe(debounceTime(150)).subscribe(datesSetArg => {
      this.onDateChange(datesSetArg)
    })
  }

  wsSub() {
    this.wsSocketSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<ShortProject>>('/topic/update/model.project.Project', this)
      .subscribe(() => {
        this.calendarEventsService.syncedSubj.next()
      })
  }
}
